import React from 'react';
import { getHeaderAndParagraphCustomStylesWUT, useRicosTheme } from '../../../theme/ricos-theme-utils';
import RicosViewer from '../../../ui/ricos-viewer/ricos-viewer';
import { ToggleTruncateButtonWUT } from '../../../ui/ricos-viewer/toggle-truncate-button-wut';
import { useTruncateRicosContent } from '../../../ui/ricos-viewer/use-truncate-ricos-content';
const RICOS_THEME = {
    customStyles: getHeaderAndParagraphCustomStylesWUT()
};
export const RichTextWUT = ({ content, maxShownParagraphs, id, FieldLayout })=>{
    const customTheme = useRicosTheme(RICOS_THEME);
    const { displayedContent, isTruncated, isTruncateButtonShown, toggleTruncate } = useTruncateRicosContent(content, maxShownParagraphs);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id
    }, /*#__PURE__*/ React.createElement(RicosViewer, {
        content: displayedContent,
        customTheme: customTheme
    }), isTruncateButtonShown && /*#__PURE__*/ React.createElement(ToggleTruncateButtonWUT, {
        isTruncated: isTruncated,
        onClick: toggleTruncate
    }));
};

//# sourceMappingURL=rich-text-wut.js.map